/**
 * Fixture for the session-status widget — shape of session_status's
 * structured output: sessionView (mcp/server.ts) + lines + teamRef.
 * The live needs-human state exercises the widget's marquee features:
 * scan bar, transcript tail, quick-response row, Stop.
 */
import {
  LIVE_SESSION_ID,
  LIVE_SESSION_LINES,
  MACHINES,
  NEEDS_HUMAN_SCREEN,
  minAgo,
} from "./seed";

export type SessionStatusFixture = Record<string, unknown> & {
  status: string;
  needsHuman: boolean;
  needsHumanScreen: string | null;
  endedAt: string | null;
  lines: string[];
};

export function sessionStatusFixture(): SessionStatusFixture {
  return {
    // sessionView fields (mcp/server.ts sessionView) —
    sessionId: LIVE_SESSION_ID,
    agent: "email-triage",
    machineId: MACHINES.mini.machineId,
    status: "running",
    startedAt: minAgo(14),
    endedAt: null,
    errorMessage: null,
    lastSeq: 47,
    inputTokens: 48_200,
    outputTokens: 9_400,
    cacheReadTokens: 512_000,
    cacheWriteTokens: 38_000,
    needsHuman: true,
    needsHumanScreen: NEEDS_HUMAN_SCREEN,
    // Phase-9 §C/§B: dispatch assignment + watchdog flag.
    model: null,
    effort: null,
    overBudget: false,
    // — plus the transcript tail and tenancy ref session_status adds.
    lines: [...LIVE_SESSION_LINES],
    teamRef: null,
  };
}

/** Demo-mode stop_session: wind the card down to a believable "ended". */
export function applyDemoStop(fix: SessionStatusFixture): void {
  fix.status = "ended";
  fix.endedAt = new Date().toISOString();
  fix.needsHuman = false;
  fix.needsHumanScreen = null;
  fix.lines = [
    ...fix.lines,
    "[48] system: stop requested — session wound down (gallery demo)",
  ];
}

/** Demo-mode respond_to_prompt: clear the needs-human row in place. */
export function applyDemoResponse(
  fix: SessionStatusFixture,
  response: string
): void {
  fix.needsHuman = false;
  fix.needsHumanScreen = null;
  fix.lines = [
    ...fix.lines,
    `[48] user: ${response}`,
    "[49] assistant: Sent — 3 replies on their way. (gallery demo)",
  ];
}
